<template>
    <div class="apprentice-simple-card">
        <div class="invite-students-left-table">
            <design-2021-apprentice-data-table
                :items="allStudents"
                :show-empty="true"
                :fields="fields">
                <template v-slot:options>
                    <b-button
                        class="btn-upload btn-assignment-import-list"
                        v-if="isAdmin"
                        variant="primary"
                        @click="importList">
                        {{ $t('group_pair.import_list') }}
                    </b-button>
                    <b-button
                        class="btn-add btn-add-students"
                        variant="primary"
                        @click="openAddStudentModal">
                        {{ $t('group_pair.add_students') }}
                    </b-button>

                    <b-button
                        class="btn-add btn-add-classes"
                        v-if="hasLas"
                        variant="primary"
                        @click="openLasModal">
                        {{ $t('group_pair.add_classes') }}
                    </b-button>

                    <b-button
                        class="btn-download"
                        v-if="students.length"
                        :href="downloadUrl"
                        target="_blank"
                        variant="primary">
                        Download
                    </b-button>
                </template>

                <template v-slot:cell(actions)="data">
                    <div class="actions">
                        <b-button
                            class="btn-remove btn-remove-student"
                            v-b-tooltip.hover
                            variant="danger-icon-only"
                            :title="$t('common.delete')"
                            @click="onDelete(data.item)">
                        </b-button>
                    </div>
                </template>

                <template #empty="scope">
                    <div class="not-found">
                        <div class="icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-notice group-admin-message">
                            {{ $t('group_pair.no_students_found') }}
                        </div>
                    </div>
                </template>
            </design-2021-apprentice-data-table>

            <design-2021-group-show-connect-las-modal-component
                @closed="addGroups"
                ref-name="group-pair-student-las-modal"
                :button-text="$t('group_pair.add_students_from_classes')"
                :group-in="group">
            </design-2021-group-show-connect-las-modal-component>

            <design-2021-group-pair-index-add-student-modal-component
                :group-id="groupIdIn"
                ref="add-students-modal">
            </design-2021-group-pair-index-add-student-modal-component>
        </div>

        <!--        <div class="not-found with-header empty-invite-students-list" v-else>-->
        <!--            <div class="icon">-->
        <!--                <i class="fas fa-exclamation-circle"></i>-->
        <!--            </div>-->
        <!--            <div class="alert-notice">Er zijn geen leerlingen gevonden zonder groepje of de optie voor "samenwerkingspartner" is uitgeschakkeld.</div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-group-pair-index-students-left-component',
    props: ['groupIdIn', 'hasLas'],
    data() {
        return {
            las_groups_loaded: false,
            all_students_loaded: false,
            students: [],
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            downloadUrl: this.routes.baseUrl() + this.routes.groupPairDownloadStudentsLeft(this.groupIdIn),
            group: {},
            isAdmin: !!AuthIsAdmin,
        };
    },

    mounted() {
        ords.use('group_pair_students')
            .with('user')
            .whereDoesntHave('group_pair_groups')
            .get()
            .subscribe((students) => {
                this.students = students;
            });

        ords.use('group')
            .with(['las_groups', 'las_main_groups'])
            .find(this.groupIdIn)
            .subscribe((group) => {
                this.group = group;
            });
    },

    methods: {
        loadLasGroups() {
            const promise_1 = this.axios.get(this.routes.groupPairLasGroups(this.groupIdIn));
            promise_1.then(
                (response) => {
                    ords.use('las_groups').add(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            const promise_2 = this.axios.get(this.routes.groupPairLasMainGroups(this.groupIdIn));
            promise_2.then(
                (response) => {
                    ords.use('las_main_groups').add(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            return [promise_1, promise_2];
        },

        loadAllStudents() {
            const promise = this.axios.get(this.routes.groupPossibleInviteStudents(this.groupIdIn));
            promise.then(
                (response) => {
                    ords.use('user').add(
                        response.data.map((user) => {
                            // in the backend las_groups is groups and las_main_groups is main_group so we have to map it.
                            if (!user.las_student) {
                                return user;
                            }
                            let las_student = user.las_student;
                            las_student.las_groups = las_student.groups;
                            las_student.las_main_groups = las_student.main_group;
                            delete las_student.groups;
                            delete las_student.main_group;
                            user.las_student = las_student;
                            return user;
                        }),
                    );
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            return [promise];
        },

        openAddStudentModal() {
            if (this.all_students_loaded) {
                this.$bvModal.show('group-pair-index-add-student-modal');
                return;
            }

            this.alert.loading();

            let lasPromises = [];
            if (!this.las_groups_loaded && this.hasLas) {
                lasPromises = this.loadLasGroups();
            }
            let studentPromises = this.loadAllStudents();
            const promises = [...lasPromises, ...studentPromises];

            Promise.all(promises).then(() => {
                this.alert.loaded();
                this.las_groups_loaded = true;
                this.all_students_loaded = true;
                this.$bvModal.show('group-pair-index-add-student-modal');
            });
        },

        openLasModal() {
            if (this.las_groups_loaded) {
                this.$bvModal.show('group-pair-student-las-modal');
                return;
            }

            this.alert.loading();
            const promises = this.loadLasGroups();

            Promise.all(promises).then(() => {
                this.alert.loaded();
                this.las_groups_loaded = true;
                this.$bvModal.show('group-pair-student-las-modal');
            });
        },

        onDelete(groupStudent) {
            this.alert
                .confirm(
                    this.$t('group_pair.delete_student'),
                    this.$t('group_pair.are_you_sure_you_want_to_delete_this_student'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.groupPairStudentDelete(groupStudent.id)).then(
                            (response) => {
                                const student = this.students.filter((student) => student.id === groupStudent.id);
                                student[0].remove();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        addGroups() {
            this.alert.saving();
            this.axios.get(this.routes.groupLasCreateGroupStudents(this.groupIdIn)).then(
                (response) => {
                    ords.hold();

                    // this should be fixed with new roms, currently the attach doesn't work automatically reversed
                    ords.use('user').add(response.data);
                    for (const user of response.data) {
                        for (const groupPairStudent of user.group_pair_students) {
                            ords.use('group_pair_students').attach(groupPairStudent.id, 'user', user.id);
                        }
                    }

                    ords.continue();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        importList() {
            window.location.href = this.routes.groupPairImport(this.groupIdIn);
        },
    },

    computed: {
        allStudents() {
            if (this.students.length === 0) {
                return [];
            }

            return this.students.map((student) => {
                return {
                    id: student.id,
                    full_name: student.user.full_name,
                    email: student.user.email,
                };
            });
        },
    },
};
</script>

<style scoped lang="scss">
.invite-students-left-table ::v-deep {
    .apprentice-table-header {
        .options {
            > .btn {
                &:not(:last-child) {
                    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .invite-students-left-table ::v-deep {
        .apprentice-table-header {
            .options {
                justify-content: space-between;

                > .btn {
                    &:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .invite-students-left-table ::v-deep {
        .apprentice-table-header {
            .options {
                justify-content: flex-end;

                > .btn {
                    &:not(:last-child) {
                        margin-bottom: 0;
                        margin-right: map-get($grid-gutter-spacing, 'fifteen');
                    }
                }
            }
        }
    }
}
</style>
